import { matchPath } from "react-router-dom"

import routes, { getRouteDisplayName, routeBuilder } from "@/lib/routes"

const breadcrumbRoutes: string[] = [
  routes.dashboard.base,
  routes.dashboard.assessment,
  routes.dashboard.learning,
  routes.dashboard.teachers,
]

const matchRoute = (pathname: string) => {
  for (const path of breadcrumbRoutes) {
    const match = matchPath({ path, end: true }, pathname)

    if (match) {
      return {
        breadcrumb: {
          label: getRouteDisplayName(path),
          path,
        },
        params: match.params as Record<string, string>,
      }
    }
  }
  return null
}

export const buildTrail = (pathname: string, cameFrom?: string) => {
  const matched = matchRoute(pathname)
  if (!matched) return []

  const { breadcrumb, params } = matched
  const currentTrail: { path: string; label: string }[] = []

  if (cameFrom) {
    const cameFromMatch = matchRoute(cameFrom)
    if (cameFromMatch) {
      currentTrail.push({
        path: routeBuilder(
          cameFromMatch.breadcrumb.path as any,
          cameFromMatch.params,
        ),
        label: cameFromMatch.breadcrumb.label,
      })
    }
  }

  currentTrail.push({
    path: routeBuilder(breadcrumb.path as any, params),
    label: breadcrumb.label,
  })

  return currentTrail
}
